import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AIRPORT_LIST = [
  // ================= INDIA =================
  { code: "DEL", city: "Delhi", name: "Indira Gandhi International Airport", country: "India" },
  { code: "BOM", city: "Mumbai", name: "Chhatrapati Shivaji Maharaj International Airport", country: "India" },
  { code: "BLR", city: "Bengaluru", name: "Kempegowda International Airport", country: "India" },
  { code: "HYD", city: "Hyderabad", name: "Rajiv Gandhi International Airport", country: "India" },
  { code: "CCU", city: "Kolkata", name: "Netaji Subhash Chandra Bose Airport", country: "India" },
  { code: "MAA", city: "Chennai", name: "Chennai International Airport", country: "India" },
  { code: "AMD", city: "Ahmedabad", name: "Sardar Vallabhbhai Patel Airport", country: "India" },
  { code: "PNQ", city: "Pune", name: "Pune Airport", country: "India" },
  { code: "GOI", city: "Goa (Dabolim)", name: "Dabolim Airport", country: "India" },
  { code: "GOX", city: "Goa (Mopa)", name: "Manohar International Airport", country: "India" },
  { code: "PAT", city: "Patna", name: "Jay Prakash Narayan Airport", country: "India" },
  { code: "LKO", city: "Lucknow", name: "Chaudhary Charan Singh Airport", country: "India" },
  { code: "JAI", city: "Jaipur", name: "Jaipur International Airport", country: "India" },
  { code: "IXC", city: "Chandigarh", name: "Shaheed Bhagat Singh Airport", country: "India" },
  { code: "ATQ", city: "Amritsar", name: "Sri Guru Ram Dass Jee Airport", country: "India" },
  { code: "VNS", city: "Varanasi", name: "Lal Bahadur Shastri Airport", country: "India" },
  { code: "BBI", city: "Bhubaneswar", name: "Biju Patnaik International Airport", country: "India" },
  { code: "GAU", city: "Guwahati", name: "Lokpriya Gopinath Bordoloi Airport", country: "India" },
  { code: "COK", city: "Kochi", name: "Cochin International Airport", country: "India" },
  { code: "TRV", city: "Thiruvananthapuram", name: "Trivandrum Airport", country: "India" },
  { code: "CCJ", city: "Kozhikode", name: "Calicut International Airport", country: "India" },
  { code: "CNN", city: "Kannur", name: "Kannur International Airport", country: "India" },
  { code: "SXR", city: "Srinagar", name: "Sheikh ul-Alam Airport", country: "India" },
  { code: "IXB", city: "Bagdogra", name: "Bagdogra Airport", country: "India" },
  { code: "IDR", city: "Indore", name: "Devi Ahilyabai Holkar Airport", country: "India" },
  { code: "AYJ", city: "Ayodhya", name: "Maharishi Valmiki Airport", country: "India" },
  { code: "IXR", city: "Ranchi", name: "Birsa Munda Airport", country: "India" },
  { code: "RPR", city: "Raipur", name: "Swami Vivekananda Airport", country: "India" },
  { code: "DED", city: "Dehradun", name: "Jolly Grant Airport", country: "India" },
  { code: "UDR", city: "Udaipur", name: "Maharana Pratap Airport", country: "India" },
  { code: "VTZ", city: "Visakhapatnam", name: "Visakhapatnam Airport", country: "India" },
  { code: "CJB", city: "Coimbatore", name: "Coimbatore Airport", country: "India" },
  { code: "TRZ", city: "Tiruchirappalli", name: "Trichy International Airport", country: "India" },
  { code: "IXE", city: "Mangalore", name: "Mangalore International Airport", country: "India" },
  { code: "NAG", city: "Nagpur", name: "Dr. Babasaheb Ambedkar Airport", country: "India" },
  { code: "BDQ", city: "Vadodara", name: "Vadodara Airport", country: "India" },
  { code: "STV", city: "Surat", name: "Surat International Airport", country: "India" },

  // ================= UNITED STATES =================
  { code: "JFK", city: "New York", name: "John F. Kennedy International Airport", country: "USA" },
  { code: "EWR", city: "Newark / New York", name: "Newark Liberty International Airport", country: "USA" },
  { code: "LGA", city: "New York", name: "LaGuardia Airport", country: "USA" },
  { code: "LAX", city: "Los Angeles", name: "Los Angeles International Airport", country: "USA" },
  { code: "SFO", city: "San Francisco", name: "San Francisco International Airport", country: "USA" },
  { code: "ORD", city: "Chicago", name: "O'Hare International Airport", country: "USA" },
  { code: "MDW", city: "Chicago", name: "Midway International Airport", country: "USA" },
  { code: "DFW", city: "Dallas / Fort Worth", name: "Dallas/Fort Worth International Airport", country: "USA" },
  { code: "DAL", city: "Dallas", name: "Dallas Love Field", country: "USA" },
  { code: "ATL", city: "Atlanta", name: "Hartsfield-Jackson Atlanta Airport", country: "USA" },
  { code: "MIA", city: "Miami", name: "Miami International Airport", country: "USA" },
  { code: "FLL", city: "Fort Lauderdale", name: "Fort Lauderdale-Hollywood Airport", country: "USA" },
  { code: "MCO", city: "Orlando", name: "Orlando International Airport", country: "USA" },
  { code: "SEA", city: "Seattle", name: "Seattle-Tacoma International Airport", country: "USA" },
  { code: "BOS", city: "Boston", name: "Logan International Airport", country: "USA" },
  { code: "IAD", city: "Washington D.C.", name: "Washington Dulles International Airport", country: "USA" },
  { code: "DCA", city: "Washington D.C.", name: "Ronald Reagan Washington National Airport", country: "USA" },
  { code: "BWI", city: "Baltimore / DC", name: "Baltimore/Washington International Airport", country: "USA" },
  { code: "IAH", city: "Houston", name: "George Bush Intercontinental Airport", country: "USA" },
  { code: "HOU", city: "Houston", name: "William P. Hobby Airport", country: "USA" },
  { code: "DEN", city: "Denver", name: "Denver International Airport", country: "USA" },
  { code: "LAS", city: "Las Vegas", name: "Harry Reid International Airport", country: "USA" },
  { code: "DTW", city: "Detroit", name: "Detroit Metropolitan Airport", country: "USA" },
  { code: "PHX", city: "Phoenix", name: "Phoenix Sky Harbor Airport", country: "USA" },
  { code: "MSP", city: "Minneapolis", name: "Minneapolis-Saint Paul Airport", country: "USA" },
  { code: "CLT", city: "Charlotte", name: "Charlotte Douglas International Airport", country: "USA" },
  { code: "PHL", city: "Philadelphia", name: "Philadelphia International Airport", country: "USA" },
  { code: "SAN", city: "San Diego", name: "San Diego International Airport", country: "USA" },
  { code: "TPA", city: "Tampa", name: "Tampa International Airport", country: "USA" },
  { code: "PDX", city: "Portland", name: "Portland International Airport", country: "USA" },
  { code: "SLC", city: "Salt Lake City", name: "Salt Lake City International Airport", country: "USA" },
  { code: "AUS", city: "Austin", name: "Austin-Bergstrom International Airport", country: "USA" },
  { code: "HNL", city: "Honolulu", name: "Daniel K. Inouye International Airport", country: "USA" },

  // ================= CANADA =================
  { code: "YYZ", city: "Toronto", name: "Toronto Pearson International Airport", country: "Canada" },
  { code: "YVR", city: "Vancouver", name: "Vancouver International Airport", country: "Canada" },
  { code: "YUL", city: "Montreal", name: "Montréal-Trudeau International Airport", country: "Canada" },
  { code: "YYC", city: "Calgary", name: "Calgary International Airport", country: "Canada" },
  { code: "YEG", city: "Edmonton", name: "Edmonton International Airport", country: "Canada" },
  { code: "YOW", city: "Ottawa", name: "Ottawa Macdonald-Cartier Airport", country: "Canada" },

  // ================= UNITED KINGDOM & EUROPE =================
  { code: "LHR", city: "London", name: "Heathrow Airport", country: "United Kingdom" },
  { code: "LGW", city: "London", name: "Gatwick Airport", country: "United Kingdom" },
  { code: "MAN", city: "Manchester", name: "Manchester Airport", country: "United Kingdom" },
  { code: "EDI", city: "Edinburgh", name: "Edinburgh Airport", country: "United Kingdom" },
  { code: "DUB", city: "Dublin", name: "Dublin Airport", country: "Ireland" },
  { code: "CDG", city: "Paris", name: "Charles de Gaulle Airport", country: "France" },
  { code: "FRA", city: "Frankfurt", name: "Frankfurt Airport", country: "Germany" },
  { code: "MUC", city: "Munich", name: "Munich Airport", country: "Germany" },
  { code: "AMS", city: "Amsterdam", name: "Amsterdam Airport Schiphol", country: "Netherlands" },
  { code: "ZRH", city: "Zurich", name: "Zurich Airport", country: "Switzerland" },
  { code: "FCO", city: "Rome", name: "Leonardo da Vinci-Fiumicino Airport", country: "Italy" },
  { code: "MAD", city: "Madrid", name: "Adolfo Suárez Madrid-Barajas Airport", country: "Spain" },
  { code: "BCN", city: "Barcelona", name: "Josep Tarradellas Barcelona-El Prat", country: "Spain" },
  { code: "LIS", city: "Lisbon", name: "Humberto Delgado Airport", country: "Portugal" },
  { code: "IST", city: "Istanbul", name: "Istanbul Airport", country: "Turkey" },

  // ================= MIDDLE EAST & ASIA =================
  { code: "DXB", city: "Dubai", name: "Dubai International Airport", country: "UAE" },
  { code: "AUH", city: "Abu Dhabi", name: "Zayed International Airport", country: "UAE" },
  { code: "DOH", city: "Doha", name: "Hamad International Airport", country: "Qatar" },
  { code: "KWI", city: "Kuwait City", name: "Kuwait International Airport", country: "Kuwait" },
  { code: "BAH", city: "Bahrain", name: "Bahrain International Airport", country: "Bahrain" },
  { code: "RUH", city: "Riyadh", name: "King Khalid International Airport", country: "Saudi Arabia" },
  { code: "JED", city: "Jeddah", name: "King Abdulaziz International Airport", country: "Saudi Arabia" },
  { code: "SIN", city: "Singapore", name: "Singapore Changi Airport", country: "Singapore" },
  { code: "BKK", city: "Bangkok", name: "Suvarnabhumi Airport", country: "Thailand" },
  { code: "KUL", city: "Kuala Lumpur", name: "Kuala Lumpur International Airport", country: "Malaysia" },
  { code: "DPS", city: "Bali", name: "Ngurah Rai International Airport", country: "Indonesia" },
  { code: "HKG", city: "Hong Kong", name: "Hong Kong International Airport", country: "Hong Kong" },
  { code: "NRT", city: "Tokyo", name: "Narita International Airport", country: "Japan" },
  { code: "HND", city: "Tokyo", name: "Haneda Airport", country: "Japan" },
  { code: "ICN", city: "Seoul", name: "Incheon International Airport", country: "South Korea" },
  { code: "KTM", city: "Kathmandu", name: "Tribhuvan International Airport", country: "Nepal" },
  { code: "CMB", city: "Colombo", name: "Bandaranaike International Airport", country: "Sri Lanka" },
  { code: "MLE", city: "Male", name: "Velana International Airport", country: "Maldives" },
  { code: "DAC", city: "Dhaka", name: "Hazrat Shahjalal Airport", country: "Bangladesh" },

  // ================= AUSTRALIA & OCEANIA =================
  { code: "SYD", city: "Sydney", name: "Sydney Kingsford Smith Airport", country: "Australia" },
  { code: "MEL", city: "Melbourne", name: "Melbourne Airport", country: "Australia" },
  { code: "BNE", city: "Brisbane", name: "Brisbane Airport", country: "Australia" },
  { code: "PER", city: "Perth", name: "Perth Airport", country: "Australia" },
  { code: "AKL", city: "Auckland", name: "Auckland Airport", country: "New Zealand" }
];

const MyComponent = () => {
  const navigate = useNavigate();

  const [tripType, setTripType] = useState("roundTrip");
  const [originInput, setOriginInput] = useState("DEL");
  const [selectedOrigin, setSelectedOrigin] = useState(AIRPORT_LIST[0]);
  const [showOriginDropdown, setShowOriginDropdown] = useState(false);

  const [destInput, setDestInput] = useState("DXB");
  const [selectedDest, setSelectedDest] = useState(
    AIRPORT_LIST.find((a) => a.code === "DXB") || AIRPORT_LIST[1]
  );
  const [showDestDropdown, setShowDestDropdown] = useState(false);

  const todayStr = new Date().toISOString().split("T")[0];
  const nextWeek = new Date(Date.now() + 7 * 86400000).toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(todayStr);
  const [toDate, setToDate] = useState(nextWeek);
  const [cabin, setCabin] = useState("ECONOMY");
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);

  const filterAirports = (query) => {
    if (!query) return AIRPORT_LIST.slice(0, 8);
    const q = query.trim().toLowerCase();
    return AIRPORT_LIST.filter(
      (a) =>
        a.code.toLowerCase().includes(q) ||
        a.city.toLowerCase().includes(q) ||
        a.name.toLowerCase().includes(q) ||
        a.country.toLowerCase().includes(q)
    ).slice(0, 10);
  };

  const originList = filterAirports(originInput);
  const destList = filterAirports(destInput);

  const handleSelectOrigin = (airport) => {
    setSelectedOrigin(airport);
    setOriginInput(airport.code);
    setShowOriginDropdown(false);
  };

  const handleSelectDest = (airport) => {
    setSelectedDest(airport);
    setDestInput(airport.code);
    setShowDestDropdown(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();

    const originCode = (selectedOrigin ? selectedOrigin.code : originInput.trim()).toUpperCase();
    const destCode = (selectedDest ? selectedDest.code : destInput.trim()).toUpperCase();

    const airportOriginObj = [
      {
        name: selectedOrigin?.name || `${originCode} Airport`,
        address: {
          cityName: selectedOrigin?.city || originCode,
          cityCode: originCode,
          countryName: selectedOrigin?.country || "Airport"
        }
      }
    ];

    const airportDestObj = [
      {
        name: selectedDest?.name || `${destCode} Airport`,
        address: {
          cityName: selectedDest?.city || destCode,
          cityCode: destCode,
          countryName: selectedDest?.country || "Airport"
        }
      }
    ];

    navigate("/flightresult", {
      state: {
        details: {
          origin: originCode,
          destination: destCode,
          from: fromDate,
          to: tripType === "roundTrip" ? toDate : null,
          cabin: cabin,
          passengerData: {
            adults: parseInt(adults, 10) || 1,
            children: parseInt(children, 10) || 0,
            infant: parseInt(infants, 10) || 0
          }
        },
        airportorigin: airportOriginObj,
        airportdestination: airportDestObj,
        tripType: tripType
      }
    });
  };

  return (
    <div className="flight_search_box bg-white p-4 rounded shadow-sm">
      <div className="d-flex gap-4 mb-3">
        <label className="me-3 cursor-pointer">
          <input
            type="radio"
            name="tripType"
            value="roundTrip"
            checked={tripType === "roundTrip"}
            onChange={(e) => setTripType(e.target.value)}
            className="me-1"
          />
          Round Trip
        </label>
        <label className="cursor-pointer">
          <input
            type="radio"
            name="tripType"
            value="oneWay"
            checked={tripType === "oneWay"}
            onChange={(e) => setTripType(e.target.value)}
            className="me-1"
          />
          One Way
        </label>
      </div>

      <form onSubmit={handleSearch}>
        <div className="row g-2 align-items-end">
          {/* Origin */}
          <div className="col-md-3 position-relative">
            <label className="form-label small font-weight-bold mb-1">From</label>
            <input
              type="text"
              className="form-control"
              value={originInput}
              placeholder="City, Country or Code (e.g. DEL, London)"
              autoComplete="off"
              onFocus={() => setShowOriginDropdown(true)}
              onChange={(e) => {
                setOriginInput(e.target.value);
                setShowOriginDropdown(true);
              }}
              required
            />
            {showOriginDropdown && originList.length > 0 && (
              <div
                className="position-absolute bg-white border rounded shadow w-100 mt-1"
                style={{ zIndex: 1050, maxHeight: "220px", overflowY: "auto" }}
              >
                {originList.map((a) => (
                  <div
                    key={a.code}
                    className="p-2 border-bottom cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSelectOrigin(a)}
                  >
                    <div className="d-flex justify-content-between">
                      <strong>{a.city}</strong>
                      <span className="badge bg-light text-dark border">{a.code}</span>
                    </div>
                    <div className="small text-muted text-truncate">{a.name} ({a.country})</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Destination */}
          <div className="col-md-3 position-relative">
            <label className="form-label small font-weight-bold mb-1">To</label>
            <input
              type="text"
              className="form-control"
              value={destInput}
              placeholder="City, Country or Code (e.g. DXB, New York)"
              autoComplete="off"
              onFocus={() => setShowDestDropdown(true)}
              onChange={(e) => {
                setDestInput(e.target.value);
                setShowDestDropdown(true);
              }}
              required
            />
            {showDestDropdown && destList.length > 0 && (
              <div
                className="position-absolute bg-white border rounded shadow w-100 mt-1"
                style={{ zIndex: 1050, maxHeight: "220px", overflowY: "auto" }}
              >
                {destList.map((a) => (
                  <div
                    key={a.code}
                    className="p-2 border-bottom cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSelectDest(a)}
                  >
                    <div className="d-flex justify-content-between">
                      <strong>{a.city}</strong>
                      <span className="badge bg-light text-dark border">{a.code}</span>
                    </div>
                    <div className="small text-muted text-truncate">{a.name} ({a.country})</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Departure Date */}
          <div className="col-md-2">
            <label className="form-label small font-weight-bold mb-1">Depart</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              min={todayStr}
              onChange={(e) => setFromDate(e.target.value)}
              required
            />
          </div>

          {/* Return Date */}
          {tripType === "roundTrip" && (
            <div className="col-md-2">
              <label className="form-label small font-weight-bold mb-1">Return</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                min={fromDate || todayStr}
                onChange={(e) => setToDate(e.target.value)}
                required
              />
            </div>
          )}

          {/* Submit */}
          <div className={tripType === "roundTrip" ? "col-md-2" : "col-md-4"}>
            <button type="submit" className="btn btn-danger w-100 py-2 font-weight-bold">
              Search Flights
            </button>
          </div>
        </div>

        {/* Passengers & Class */}
        <div className="row g-2 mt-2 pt-2 border-top">
          <div className="col-md-3">
            <label className="form-label small text-muted mb-0">Class</label>
            <select className="form-select form-select-sm" value={cabin} onChange={(e) => setCabin(e.target.value)}>
              <option value="ECONOMY">Economy</option>
              <option value="PREMIUM_ECONOMY">Premium Economy</option>
              <option value="BUSINESS">Business</option>
              <option value="FIRST">First Class</option>
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label small text-muted mb-0">Adults (12+)</label>
            <input
              type="number"
              className="form-control form-control-sm"
              min="1"
              max="9"
              value={adults}
              onChange={(e) => setAdults(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label small text-muted mb-0">Children (2-11)</label>
            <input
              type="number"
              className="form-control form-control-sm"
              min="0"
              max="8"
              value={children}
              onChange={(e) => setChildren(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label small text-muted mb-0">Infants</label>
            <input
              type="number"
              className="form-control form-control-sm"
              min="0"
              max="4"
              value={infants}
              onChange={(e) => setInfants(e.target.value)}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default MyComponent;
